import React from 'react';
/** icon-checkmark-strong-m */
/** icon-checkmark-strong */
export default () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
            d="M13.614 2.984 C 13.552 3.005,13.443 3.057,13.373 3.101 C 13.303 3.144,11.728 4.695,9.874 6.548 L 6.502 9.917 5.270 8.681 C 4.592 8.002,3.944 7.365,3.831 7.267 C 3.559 7.032,3.410 6.963,3.171 6.960 C 2.917 6.958,2.710 7.060,2.465 7.308 C 2.224 7.553,2.121 7.760,2.121 8.004 C 2.121 8.368,2.068 8.305,4.135 10.372 C 6.153 12.390,6.113 12.354,6.450 12.377 C 6.669 12.391,6.798 12.350,7.012 12.196 C 7.222 12.046,14.608 4.654,14.726 4.477 C 14.979 4.095,14.924 3.719,14.557 3.327 C 14.275 3.025,13.902 2.890,13.614 2.984 "
            stroke="none"
            fillRule="evenodd"
            fill="#1A2B49"
        />
    </svg>
);
